import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class FonctionsService {

  loading: boolean = false;

  constructor(
    private toastr: ToastrService,) { }


  launch_toast(isSuccess: boolean = true, message: string = '', withTroduction: boolean = true) {

    let msg: string = message;

    if (isSuccess) {

      if (message == '') {
        this.toastr.success(msg, '', {
        });

      } else if (message.length > 1) {

        if (withTroduction) {
          this.toastr.success(msg, '', {
          });
        } else if (!withTroduction) {
          this.toastr.success(message, '', {
          })
        }

      }

    } else {

      if (message == '') {
        this.toastr.error(msg, '', {
        });
      } else if (message.length > 1) {

        if (withTroduction) {
          this.toastr.error(msg, '', {
          });
        } else if (!withTroduction) {
          this.toastr.error(message, '', {
          })
        }


      }


    }

  }

  loading_screen(valeur: boolean) {
    this.loading = valeur;
    setTimeout(() => {
      this.loading = false;
    }, 5000);
  }
}
